import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'
import Layout from '@/components/common/Layout'
import {
  Message
} from 'element-ui';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/views/login/index.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/loginOut',
      name: 'loginOut',
      component: () => import('../components/views/loginOut/index.vue'),
      meta: {
        title: '退出登录'
      }
    },
    {
      path: '/',
      component: () => import('../components/common/Home.vue'),
      meta: {
        title: '自述文件'
      },
      children: [{
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('../components/common/Dashboard.vue'),
          meta: {
            title: '主页'
          }
        },
        {
          path: '/board',
          name: 'board',
          component: () => import('../components/views/system/board/board.vue'),
          meta: {
            title: '看板'
          }
        },
        {
          path: '/oss',
          name: 'oss',
          component: () => import('../components/views/system/oss/oss.vue'),
          meta: {
            title: 'oss测试'
          }
        },
        {
          path: '/kpi',
          name: 'kpi',
          component: () => import('../components/views/kpi/kpi_list'),
          meta: {
            title: 'kpi'
          }
        },
        {
          path: '/system',
          name: 'system',
          component: Layout,
          children: [{
              path: 'loginLog',
              name: 'loginLog',
              component: () => import('../components/views/system/log/login_log.vue'),
              meta: {
                title: '登录日志'
              }
            },
            {
              path: 'organization',
              name: 'organization',
              component: () => import('../components/views/system/organization/organization'),
              meta: {
                title: '机构管理'
              }
            },
            {
              path: 'cityOrganization',
              name: 'cityOrganization',
              component: () => import('../components/views/system/cityOrganization/cityOrganization'),
              meta: {
                title: '（地）机构管理'
              }
            },
            {
              path: 'operateLog',
              name: 'operateLog',
              component: () => import('../components/views/system/log/operate_log'),
              meta: {
                title: '操作日志'
              }
            },
            {
              path: 'employee',
              name: 'employee',
              component: () => import('../components/views/system/employee/employee.vue'),
              meta: {
                title: '员工管理'
              }
            }, {
              path: 'addressBook',
              name: 'addressBook',
              component: () => import('../components/views/system/addressBook/addressBook.vue'),
              meta: {
                title: '员工通讯录'
              }
            }, {
              path: 'addressBookAuth',
              name: 'addressBookAuth',
              component: () => import('../components/views/system/addressBook/addressBookAuth.vue'),
              meta: {
                title: '通讯录权限管理'
              }
            }, {
              path: 'org-manage',
              name: 'org-manage',
              component: () => import('../components/views/system/org-manage/org-manage.vue'),
              meta: {
                title: '机构管理'
              }
            }, {
              path: 'three-part-query',
              name: 'three-part-query',
              component: () => import('../components/views/system/three-part-query/three-part-query.vue'),
              meta: {
                title: '第三方机构查询'
              }
            }, {
              path: 'orgQuery',
              name: 'orgQuery',
              component: () => import('../components/views/system/orgQuery/orgQuery.vue'),
              meta: {
                title: '机构公司查询'
              }
            }, {
              path: 'org-area',
              name: 'org-area',
              component: () => import('../components/views/system/org-area/org-area.vue'),
              meta: {
                title: '机构区域管理'
              }
            }, {
              path: 'customer-manage',
              name: 'customer-manage',
              component: () => import('../components/views/system/customer-manage/customer-manage.vue'),
              meta: {
                title: '客户管理'
              }
            },
            {
              path: 'org-customer-manage',
              name: 'org-customer-manage',
              component: () => import('../components/views/system/org-customer-manage/org-customer-manage.vue'),
              meta: {
                title: '机构客户关系维护'
              }
            },
            {
              path: 'func',
              name: 'func',
              component: () => import('../components/views/system/func/func.vue'),
              meta: {
                title: '菜单管理'
              }
            }, {
              path: 'funcMobile',
              name: 'funcMobile',
              component: () => import('../components/views/system/func/func_mobile.vue'),
              meta: {
                title: 'mobile菜单管理'
              }
            }, {
              path: 'role',
              name: 'role',
              component: () => import('../components/views/system/role/role.vue'),
              meta: {
                title: '角色管理'
              }
            }, {
              path: 'version',
              name: 'version',
              component: () => import('../components/views/system/version/version.vue'),
              meta: {
                title: '版本管理'
              }
            }, {
              path: 'configManage',
              name: 'configManage',
              component: () => import('../components/views/system/configManage/configManage.vue'),
              meta: {
                title: '配置管理'
              }
            }, {
              path: 'activityManage',
              name: 'activityManage',
              component: () => import('../components/views/system/activityManage/activityManage.vue'),
              meta: {
                title: '活动管理'
              }
            }
          ],
        },
        {
          path: '/business',
          name: 'business',
          component: Layout,
          children: [{
              path: 'allocateClinic',
              name: 'allocateClinic',
              component: () => import('../components/views/business/allocate_clinic/allocate_clinic.vue'),
              meta: {
                title: '分配诊所(旧)'
              }
            },
            {
              path: 'allocateClinicCP',
              name: 'allocateClinicCP',
              component: () => import('../components/views/business/allocate_clinicCP/allocate_clinicCP.vue'),
              meta: {
                title: '分配诊所'
              }
            },
            {
              path: 'allocateOver',
              name: 'allocateOver',
              component: () => import('../components/views/business/allocate_clinicCP/allocate_over.vue'),
              meta: {
                title: '发短信'
              }
            },
            {
              path: 'cooperateClinic',
              name: 'cooperateClinic',
              component: () => import('../components/views/business/cooperate_clinic/cooperate_clinic.vue'),
              meta: {
                title: '合作诊所2.0'
              }
            },
            {
              path: 'complianceClinic',
              name: 'complianceClinic',
              component: () => import('../components/views/business/compliance_clinic/compliance_clinic.vue'),
              meta: {
                title: '合规诊所'
              }
            },
            {
              path: 'prescriptionManage',
              name: 'prescriptionManage',
              component: () => import('../components/views/business/prescription_manage/prescription_manage.vue'),
              meta: {
                title: '处方治理'
              }
            },

            {
              path: 'outpatientLog/:id',
              name: 'outpatientLog',
              component: () => import('../components/views/business/prescription_manage/outpatient_log.vue'),
              meta: {
                title: '门诊日志'
              }
            },
            {
              path: 'outpatientLogDetail/:id',
              name: 'outpatientLogDetail',
              component: () => import('../components/views/business/prescription_manage/outpatient_log_detail.vue'),
              meta: {
                title: '门诊日志详情'
              }
            },
            {
              path: 'outpatientLogRecords',
              name: 'outpatientLogRecords',
              component: () => import('../components/views/business/prescription_manage/outpatient_log_records.vue'),
              meta: {
                title: '患者档案'
              }
            },
            {
              path: 'outpatientLogCompare',
              name: 'outpatientLogCompare',
              component: () => import('../components/views/business/prescription_manage/outpatient_log_compare.vue'),
              meta: {
                title: '病例对比'
              }
            },
          ],
        },
        {
          path: '/businessv3',
          name: 'businessv3',
          component: Layout,
          children: [
            {
              path: 'allocateClinicCPV3',
              name: 'allocateClinicCPV3',
              component: () => import('../components/views/businessV3/allocate_clinicCPV3/index.vue'),
              meta: {
                title: '分配诊所3.0'
              }
            },
            {
              path: 'cooperateClinicV3',
              name: 'cooperateClinicV3',
              component: () => import('../components/views/businessV3/cooperate_clinic/cooperate_clinic_v3.vue'),
              meta: {
                title: '合作诊所3.0'
              }
            },
            {
              path: 'prescriptionManage',
              name: 'prescriptionManage',
              component: () => import('../components/views/businessV3/prescription-manage/prescription-manage.vue'),
              meta: {
                title: '处方治理'
              }
            },
            {
              path: 'outpatientLog/:id',
              name: 'outpatientLog',
              component: () => import('../components/views/businessV3/prescription-manage/outpatient-log.vue'),
              meta: {
                title: '门诊日志'
              }
            },
            {
              path: 'outpatientLogDetail/:id',
              name: 'outpatientLogDetail',
              component: () => import('../components/views/businessV3/prescription-manage/outpatient-log-detail.vue'),
              meta: {
                title: '门诊日志详情'
              }
            },
            {
              path: 'outpatientLogRecords',
              name: 'outpatientLogRecords',
              component: () => import('../components/views/businessV3/prescription-manage/outpatient-log-records.vue'),
              meta: {
                title: '患者档案'
              }
            },
            {
              path: 'outpatientLogCompare',
              name: 'outpatientLogCompare',
              component: () => import('../components/views/businessV3/prescription-manage/outpatient-log-compare.vue'),
              meta: {
                title: '病例对比'
              }
            },
          ],
        },
        {
          path: '/article',
          name: 'article',
          component: Layout,
          children: [{
            path: 'articleManage',
            name: 'articleManage',
            component: () => import('../components/views/article/article_manage/article.vue'),
            meta: {
              title: '文章管理'
            }
          }],
        },
         {
          path: '/classroom',
          name: 'classroom',
          component: Layout,
          children: [{
            path: 'classroomManage',
            name: 'classroomManage',
            component: () => import('../components/views/classroom/classroom_manage.vue'),
            meta: {
              title: '春播讲堂'
            }
          },
          {
            path: 'courseList',
            name: 'courseList',
            component: () => import('../components/views/classroom/course_list.vue'),
            meta: {
              title: '课程列表'
            }
          }],
        },
        {
          path: '/statisticsCenter',
          component: Layout,
          children: [{
              path: 'prescriptionStatistics',
              name: 'prescriptionStatistics',
              component: () => import('../components/views/statisticsCenter/prescription_statistics.vue'),
              meta: {
                title: '云诊所处方统计2.0'
              }
            },
            {
              path: 'sanfutieStatistics',
              name: 'sanfutieStatistics',
              component: () => import('../components/views/statisticsCenter/sanfutie_statistics.vue'),
              meta: {
                title: '三伏贴统计'
              }
            },
            {
              path: 'sanfutieWarningStatistics',
              name: 'sanfutieWarningStatistics',
              component: () => import('../components/views/statisticsCenter/sanfutieWarning_statistics.vue'),
              meta: {
                title: '诊所贴敷预警统计'
              }
            },
          ],
        },
        {
          path: '/statisticsCenterV3',
          component: Layout,
          children: [{
              path: 'prescriptionStatistics',
              name: 'prescriptionStatistics',
              component: () => import('../components/views/statisticsCenterV3/prescription_statistics.vue'),
              meta: {
                title: '云诊所处方统计3.0'
              }
            },
            // {
            //   path: 'test',
            //   name: 'test',
            //   component: () => import('../components/views/test/index.vue'),
            //   meta: { title: '云诊3.0' }
            // },
          ]
        },
        {
          path: '/document',
          name: 'document',
          component: Layout,
          children: [{
              path: 'documentManage',
              name: 'documentManage',
              component: () => import('../components/views/document/document_manage/document.vue'),
              meta: {
                title: '文件下发'
              }
            },
            {
              path: 'documentDownload',
              name: 'documentDownload',
              component: () => import('../components/views/document/document_download/document_download.vue'),
              meta: {
                title: '文件下载'
              }
            },
          ],
        },
        {
          path: '/projectCenter',
          component: Layout,
          children: [{
              path: 'study',
              name: 'study',
              component: () => import('../components/views/projectcenter/study/study.vue'),
              meta: {
                title: '制度学习'
              }
            },
            {
              path: 'appoint',
              name: 'appoint',
              component: () => import('../components/views/projectcenter/appoint/appoint.vue'),
              meta: {
                title: '预约数据'
              }
            },
            {
              path: 'material',
              name: 'material',
              component: () => import('../components/views/projectcenter/material/material.vue'),
              meta: {
                title: '宣传物料'
              }
            },
            {
              path: 'project',
              name: 'project',
              component: () => import('../components/views/projectcenter/project/project.vue'),
              meta: {
                title: '企划公告'
              }
            },
            {
              path: 'wemedia',
              name: 'wemedia',
              component: () => import('../components/views/projectcenter/wemedia/we_media.vue'),
              meta: {
                title: '自媒体报备'
              }
            },
          ],
        },
        {
          path: '/workreport',
          component: Layout,
          children: [{
            path: 'xueshu',
            name: 'xueshu',
            component: () => import('../components/views/workreport/statistics/xueshu.vue'),
            meta: {
              title: '学术人员统计'
            }
          }, ],
        },
        {
          path: '/workreport',
          component: Layout,
          children: [{
            path: 'yewu',
            name: 'yewu',
            component: () => import('../components/views/workreport/statistics/yewu.vue'),
            meta: {
              title: '业务人员统计'
            }
          }, ],
        },
        {
          path: '/workreport',
          component: Layout,
          children: [{
            path: 'other',
            name: 'other',
            component: () => import('../components/views/workreport/statistics/other.vue'),
            meta: {
              title: '学术活动统计'
            }
          }, ],
        },
        {
          path: '/workflow',
          component: Layout,
          children: [{
              path: 'auditManage',
              name: 'auditManage',
              component: () => import('../components/views/workflow/audit_manage.vue'),
              meta: {
                title: '我的待办'
              }
            },
            {
              path: 'auditHiManage',
              name: 'auditHiManage',
              component: () => import('../components/views/workflow/audit_hi_manage.vue'),
              meta: {
                title: '历史审核'
              }
            },
          ],
        },
        {
          path: '/kpi',
          component: Layout,
          children: [{
            path: 'kpi',
            name: 'kpi',
            component: () => import('../components/views/kpi/kpi_list.vue'),
            meta: {
              title: '绩效考核'
            }
          }, ],
        },
        {
          path: '/promote',
          component: Layout,
          children: [{
            path: 'launchConfig',
            name: 'launchConfig',
            component: () => import('../components/views/promote/launchConfig/launchConfig_edit'),
            meta: {
              title: '广告管理'
            }
          }, ],
        },
        {
          path: '/template',
          component: Layout,
          children: [{
              path: 'provinceTemplate',
              name: 'provinceTemplate',
              component: () => import('../components/views/template/provinceTemplate/province-template'),
              meta: {
                title: '省区模板'
              }
            },
            {
              path: 'myTemplate',
              name: 'myTemplate',
              component: () => import('../components/views/template/myTemplate/my-template'),
              meta: {
                title: '我的模板'
              }
            },
          ],
        },
        {
          path: '/activity',
          component: Layout,
          children: [{
              path: 'pediatric',
              name: 'pediatric',
              component: () => import('../components/views/activity/pediatric/pediatric'),
              meta: {
                title: '春播家医特色儿科打造'
              }
            },
            {
              path: 'modelClinic',
              name: 'modelClinic',
              component: () => import('../components/views/activity/modelClinic/model_clinic'),
              meta: {
                title: '样板诊所打造'
              }
            },
          ],
        },
        {
          path: '/officeCenter',
          component: Layout,
          children: [{
              path: 'actReg',
              name: 'actReg',
              component: () => import('../components/views/officeCenter/actReg/actReg'),
              meta: {
                title: '打造活动'
              }
            },
            {
              path: 'unfreeze',
              name: 'unfreeze',
              component: () => import('../components/views/officeCenter/unfreeze/unfreeze'),
              meta: {
                title: '长期未登录账号解禁'
              }
            },
            {
              path: 'positionTrans',
              name: 'positionTrans',
              component: () => import('../components/views/officeCenter/positionTrans/position_trans'),
              meta: {
                title: '转岗审核'
              }
            },
            {
              path: 'positionApply',
              name: 'positionApply',
              component: () => import('../components/views/officeCenter/positionApply/position_apply'),
              meta: {
                title: '资质审核'
              }
            },
            {
              path: 'idphotoApply',
              name: 'idphotoApply',
              component: () => import('../components/views/officeCenter/idphotoApply/idphoto_apply'),
              meta: {
                title: '证件照审核'
              }
            },
            {
              path: 'allocationPlan',
              name: 'allocationPlan',
              component: () => import('../components/views/officeCenter/allocationPlan/allocationPlan'),
              meta: {
                title: '年度建设目标管理'
              }
            },

          ],
        },
        {
          path: '/homeland',
          component: Layout,
          children: [{
              path: 'birthdayCall',
              name: 'birthdayCall',
              component: () => import('../components/views/homeland/birthdayCall/birthdayCall'),
              meta: {
                title: '生日关怀'
              }
            },
            {
              path: 'workYearCall',
              name: 'workYearCall',
              component: () => import('../components/views/homeland/workYearCall/workYearCall'),
              meta: {
                title: '周年关怀'
              }
            }
          ],
        },
        {
          path: '/science',
          component: Layout,
          children: [
            // {
            //   path: 'academicActivity',
            //   name: 'academicActivity',
            //   component: () => import('../components/views/science/academicActivity/academicActivity'),
            //   meta: { title: '学术活动申报' },
            // },
            {
              path: 'academicActivityRegional',
              name: 'academicActivityRegional',
              component: () => import('../components/views/science/academicActivity/regionalDepartmentsAcademic'),
              meta: {
                title: '地区学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityArea',
              name: 'academicActivityArea',
              component: () => import('../components/views/science/academicActivity/areaAcademic'),
              meta: {
                title: '地总学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityProvince',
              name: 'academicActivityProvince',
              component: () => import('../components/views/science/academicActivity/academicProvincialDirector'),
              meta: {
                title: '省区学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityProviencialManager',
              name: 'academicActivityProviencialManager',
              component: () => import('../components/views/science/academicActivity/academicProviencialManager'),
              meta: {
                title: '省总学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityHeadquarters',
              name: 'academicActivityHeadquarters',
              component: () => import('../components/views/science/academicActivity/academicHeadquarters'),
              meta: {
                title: '总部学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityPlatform',
              name: 'academicActivityPlatform',
              component: () => import('../components/views/science/academicActivity/academicPlatform'),
              meta: {
                title: '平台总监学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityFinance',
              name: 'academicActivityFinance',
              component: () => import('../components/views/science/academicActivity/academicFinance'),
              meta: {
                title: '财务学术活动申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicActivityDetails/:id?',
              name: 'academicActivityDetails',
              component: () => import('../components/views/science/academicActivity/academicActivityDetails'),
              meta: {
                title: '学术活动申报单'
              }
            },
            {
              path: 'academicActivityImport',
              name: 'academicActivityImport',
              component: () => import('../components/views/science/academicActivity/academicActivityImport'),
              meta: {
                title: '导入学术活动申报'
              }
            },
            {
              path: 'academicBudgetDetails/:id?',
              name: 'academicBudgetDetails',
              component: () => import('../components/views/science/academicActivity/academicBudgetDetails'),
              meta: {
                title: '学术预算计划'
              }
            },
            {
              path: 'academicStatistical',
              name: 'academicStatistical',
              component: () => import('../components/views/science/academicActivity/academicStatistical'),
              meta: {
                title: '学术活动资金统计'
              }
            },
            {
              path: 'academicSalaryProviencialFinance',
              name: 'academicSalaryProviencialFinance',
              component: () => import('../components/views/science/academicSalary/academicSalaryProviencialFinance'),
              meta: {
                title: '省区财务学术工资申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicSalaryProviencialManager',
              name: 'academicSalaryProviencialManager',
              component: () => import('../components/views/science/academicSalary/academicSalaryProvicencialManager'),
              meta: {
                title: '省总学术工资申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicHeadquartersDirector',
              name: 'academicHeadquartersDirector',
              component: () => import('../components/views/science/academicSalary/academicHeadquartersDirector'),
              meta: {
                title: '总部学术工资申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicSalaryPlatform',
              name: 'academicSalaryPlatform',
              component: () => import('../components/views/science/academicSalary/academicSalaryPlatform'),
              meta: {
                title: '平台总经理学术工资申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicSalaryFinancialCenter',
              name: 'academicSalaryFinancialCenter',
              component: () => import('../components/views/science/academicSalary/academicSalaryFinancialCenter'),
              meta: {
                title: '财务中心学术工资申报',
                requiresAuth: true
              },
            },
            {
              path: 'academicSalaryImport',
              name: 'academicSalaryImport',
              component: () => import('../components/views/science/academicSalary/academicSalaryImport'),
              meta: {
                title: '导入学术工资申报'
              }
            },
            {
              path: 'academicSalaryDetails/:id?',
              name: 'academicSalaryDetails',
              component: () => import('../components/views/science/academicSalary/academicSalaryDetails'),
              meta: {
                title: '学术工资申报单'
              }
            },
            {
              path: 'academicFundingDistributionCreate',
              name: 'academicFundingDistributionCreate',
              component: () => import('../components/views/science/academicFundingDistribution/academicFundingDistributionCreate'),
              meta: {
                title: '编制学术资金发放',
                requiresAuth: true
              }
            },
            {
              path: 'academicFundingDistributionCheck',
              name: 'academicFundingDistributionCheck',
              component: () => import('../components/views/science/academicFundingDistribution/academicFundingDistributionCheck'),
              meta: {
                title: '复核学术资金发放',
                requiresAuth: true
              }
            },
            {
              path: 'academicFundingStatistics',
              name: 'academicFundingStatistics',
              component: () => import('../components/views/science/academicSalary/academicFundingStatistics'),
              meta: {
                title: '学术资金统计',
                requiresAuth: true
              }
            },
            {
              path: 'salaryDistributionDetails/:id?',
              name: 'salaryDistributionDetails',
              component: () => import('../components/views/science/academicFundingDistribution/salaryDistributionDetails'),
              meta: {
                title: '学术工资发放单'
              }
            },
            {
              path: 'paySalary',
              name: 'paySalary',
              component: () => import('../components/views/science/academicSalary/paySalary'),
              meta: {
                title: '发放工资'
              }
            },
            {
              path: 'payFunds',
              name: 'payFunds',
              component: () => import('../components/views/science/academicSalary/paySalary'),
              meta: {
                title: '发放学术活动资金'
              }
            },
            {
              path: 'salaryAppropriateDetails/:id?',
              name: 'salaryAppropriateDetails',
              component: () => import('../components/views/science/academicFundingDistribution/salaryAppropriateDetails'),
              meta: {
                title: '学术活动资金发放单'
              }
            },
            {
              path: 'salaryAppropriateImport/:id?',
              name: 'salaryAppropriateImport',
              component: () => import('../components/views/science/academicFundingDistribution/salaryAppropriateImport'),
              meta: {
                title: '学术活动资金发放导入'
              }
            }
          ],
        },
        {
          path: '/science',
          component: Layout,
          children: [{
            path: 'flowSetting',
            name: 'flowSetting',
            component: () => import('../components/views/science/flowSetting/flowSetting'),
            meta: {
              title: '审批流设置',
              requiresAuth: true
            }
          }],
        },
        {
          path: '/science',
          component: Layout,
          children: [{
            path: 'academicBudget',
            name: 'academicBudget',
            component: () => import('../components/views/science/academicBudget/academicBudget'),
            meta: {
              title: '学术经费预算设置',
              requiresAuth: true
            }
          }],
        },
        {
          path: '/academic',
          component: Layout,
          children: [{
            path: 'member',
            name: 'academicMember',
            component: () => import('../components/views/academic/academic-member/index.vue'),
            meta: {
              title: '学术人员分配',
              requiresAuth: true
            }
          },
          {
            path: 'statistic-members',
            name: 'academicStatisticMembers',
            component: () => import('../components/views/academic/statistic-member/index.vue'),
            meta: {
              title: '学术指标设置',
              requiresAuth: true
            }
          },
          {
            path: 'statistic-performances',
            name: 'academicStatisticPerformances',
            component: () => import('../components/views/academic/statistic-performance/index.vue'),
            meta: {
              title: '(省办)学术业绩统计',
              requiresAuth: true
            }
          },
          {
            path: 'statistic-academic',
            name: 'academicStatistic',
            component: () => import('../components/views/academic/statistic-academic/index.vue'),
            meta: {
              title: '(学术)学术业绩统计',
              requiresAuth: true
            }
          },
          {
            path: 'statistic-clinic',
            name: 'academicStatisticClinic',
            component: () => import('../components/views/academic/statistic-clinic/index.vue'),
            meta: {
              title: '(诊所)学术业绩统计',
              requiresAuth: true
            }
          },
          {
            path: 'statistic-daily',
            name: 'academicStatisticDaily',
            component: () => import('../components/views/academic/statistic-daily/index.vue'),
            meta: {
              title: '(日报)学术业绩统计',
              requiresAuth: true
            }
          },
          {
            path: 'statistic-detail',
            name: 'academicStatisticDetail',
            component: () => import('../components/views/academic/statistic-performance/detail.vue'),
            meta: {
              title: '学术统计详情',
              requiresAuth: false
            }
          }],
        },
      ]
    },
    {
      path: '/timeaxis',
      name: 'timeaxis',
      component: () => import('../components/common/timeaxis.vue'),
      meta: {
        title: '版本信息'
      }
    }
  ]
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach(async (to, from, next) => {
  let _token = storage.get('token');
  if (_token) {
    if (store.state.menuPerms.length <= 0) { // 拿已有权限菜单
      await store.dispatch('MenusPerms');
    }
    // let personalList=""
    // let userInfo = storage.user;
    // await getPersonalConfig().then(res=>{
    //   personalList=res.data
    // })
    // commonConst.person_DATA_LIST.filter(res=>{
    //   if(userInfo[res.key]!=personalList[res.key]){
    //     userInfo[res.key]=personalList[res.key]
    //     storage.user = userInfo;
    //   }
    // })
    if (to.path === '/login') {
      next({
        path: '/'
      })
    } else {
      // console.log(store.state.menuPerms,to.name,'store.state.menuPerms===log');// 用child 更可靠，name可能会重复
      if (!to.meta.requiresAuth) { // 无权限访问
        next();
        store.dispatch('OAWaitCount')
      } else {
        if (store.state.menuPerms.includes(to.name)) { // 有权限访问
          next();
          store.dispatch('OAWaitCount')
        } else { // 无权限访问
          Message.warning('您无权限访问该页面，请联系管理员');
          next('/dashboard');
        }
      }
    }
  } else {
    to.path === '/login' ? next() : next('/login');
  }

})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js